package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import one.healthium.ui.compose.theme.AppTheme

class AppNavigationBarStyle(
    private val containerColor: Color? = null,
    private val defaultLabelColor: Color? = null,
    private val activeLabelColor: Color? = null,
) {
    val resolvedContainerColor: Color
        @Composable get() = containerColor ?: AppTheme.colors.surface

    val resolvedDefaultLabelColor: Color
        @Composable get() = defaultLabelColor ?: AppTheme.colors.text300

    val resolvedActiveLabelColor: Color
        @Composable get() = activeLabelColor ?: AppTheme.colors.text100
}
